<template>
  <div id="businessList">
    <div class="container">
      <el-button type="success" @click="addNew()">新增行业</el-button>
      <el-button
        type="danger"
        icon="el-icon-delete"
        @click="handleDelete(deleteArr)"
        >批量删除</el-button
      >
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
      <!-- @sort-change="sortChange" -->
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="busName" label="行业名称"> </el-table-column>
         
        <el-table-column label="预览">
          <template slot-scope="scope">
            <el-image
              style="width: 1.25rem; height: 1.25rem"
              v-show="scope.row.sysPicture"
              :src="scope.row.sysPicture?
                baseURL +
                scope.row.sysPicture['fileUrl'] +
                scope.row.sysPicture['newName']:''
              "
              :preview-src-list="srcList"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序"> </el-table-column>
        <!-- <el-table-column prop="updateTime" label="创建时间" :sortable="'custom'" >
          <template slot-scope="scope">
                 {{scope.row.updateTime | seTimeFilter('sjx')}}
          </template>
           </el-table-column>-->
        <el-table-column label="操作" width="180"> 
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="addNew(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageNo"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>

    </div>

    <el-dialog
      :title="isEdit?'编辑行业':'新增行业'"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :key="key"
      v-if="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        class="demo-ruleForm"
      >
        <el-form-item label="行业名称" prop="busName">
          <el-input v-model="ruleForm.busName"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="ruleForm.sort"></el-input>
        </el-form-item>
      </el-form>
      <el-upload
        class="upload-demo"
        :before-upload="beforeUpload"
        :http-request="upload"
        ref="upload"
        action=""
        :limit="1"
        :accept="'.jpg,.jpeg,.png,.JPG,.JPEG'"
        :on-exceed="overSize"
      >
        <el-button size="small" type="primary">选择行业logo</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd()">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBusinessList, addBusiness, uploadIllustration,editBusiness,delBusiness } from "@/api/manage";
import config from "@/config/url.config";
export default {
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
        
        // sortType:'a'
      },
      pageTotal:0,
      dialogVisible: false,
      newFile: new FormData(),
      key: 1,
      ruleForm: {
        busName: "",
        busPicture: "",
        sort:''
      },
      isEdit:false,
      baseURL: config.baseURL,
      tableData: [],
      deleteArr: [],
      srcList: [],
      editId:'',
      rules: {
        busName: [
          {
            required: true,
            message: "请输入行业名称",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      //获取行业应用列表
      let res = await getBusinessList(this.query);
      if (res.code == "40001") {
        this.tableData = [];
        this.srcList=[]
      } else if (res.code == "200") {
        this.tableData = res.data;
        this.pageTotal=+res.total
        this.srcList=[]
        this.tableData.map((item) => {
          let url =item.sysPicture?
            config.baseURL +
            item.sysPicture["fileUrl"] +
            item.sysPicture["newName"]:''
          this.srcList.push(url);
        });
      }
    },
    addNew(data) {
      //新增行业按钮
      this.dialogVisible = true;
      if(data){
        console.log('data',data);
        this.isEdit=true
        this.ruleForm.busName=data.busName
        this.ruleForm.busPicture=data.busPicture
        this.ruleForm.sort= data.sort
        this.editId=data.id
      }else{
        this.isEdit=false
        this.ruleForm.busName=''
        this.ruleForm.busPicture=''
        this.ruleForm.sort = this.pageTotal +1
        this.editId=''
      }
    },
    handleClose(done) {
      //弹窗关闭前的钩子
      this.$refs.upload.clearFiles();
      this.$refs["ruleForm"].resetFields();
      done();
    },
    cancelAdd() {
      //取消添加
      this.$refs.upload.clearFiles();
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    confirmAdd() {
      //确认添加
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          if(!this.isEdit){
            if (this.ruleForm.busPicture == "") {
            return this.$message.error("未上传行业logo");
          }
          let res = await addBusiness(this.ruleForm);
          if (res.code == "200") {
            this.newFile.delete('file')
            this.$message.success("新增行业成功！");
            this.$refs.upload.clearFiles();
            this.$refs["ruleForm"].resetFields();
            this.dialogVisible = false;
            this.getData()
          }
          }else{
           let param =JSON.parse(JSON.stringify(this.ruleForm))
            param.id =this.editId
           let res = await editBusiness(param)
           if(res.code=='200'){
             this.newFile.delete('file')
             this.$message.success("编辑行业成功！");
            this.isEdit=false
            this.$refs["ruleForm"].resetFields();
            this.dialogVisible = false;
            this.getData()
           }
          }
        }
      });
    },
    beforeUpload(file) {
      //文件上传之前的钩子
      if (file) {
         let arr=['image/jp2','image/jepg','image/png','image/jpeg']
        if(arr.includes(file.type)){
         this.newFile.append("file", file);
        }else{
          this.$message.error('插图只能上传jpg/png格式文件！')
          return false
        }
      } else {
        return false;
      }
    },
    async upload() {
      //文件上传时的钩子
      let res = await uploadIllustration(this.newFile);
      if (res.code == 200) {
        this.ruleForm.busPicture = res.data.id;
        this.$message.success("logo上传成功！");
      }
    },
    handleSelectionChange(val) {
      //多选操作,批量删除
      this.deleteArr = [];
      val.map((item) => {
        this.deleteArr.push(item.id);
      });
    },
    handleDelete(ids){
      //删除,批量删除
      if(ids.length==0){
      return this.$message.error('未选择删除项')
    }
      this.$confirm("此操作将永久删除该行业, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let param = {};
          if (ids.length == 0) {
            param.ids = "";
          } else {
            param.ids = Array.isArray(ids)
              ? JSON.stringify(ids)
              : JSON.stringify([ids]);
          }
          let res = await delBusiness(param);
          if (res.code == 200) {
            if((JSON.parse(param.ids)).length==this.tableData.length){
             this.query.pageNo--
           }
            this.$message.success('删除成功！')
            this.getData();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handlePageChange(val) {
      //翻页功能
          this.$set(this.query, 'pageNo', val);
          this.getData();
      },
      overSize(){
      this.$message.error('logo最多只能上传一张！')
    }
      // sortChange(){
      //    this.query.sortType?this.query.sortType='':this.query.sortType='a'
      //     this.getData()
      // }
  },
  computed: {
  	leaveDataNew() {
        return JSON.parse(JSON.stringify(this.ruleForm.sort))//watch监听要求
  	},
 },
  watch: {
    leaveDataNew:{
      handler:function(newVal,oldVal){
        var reg = /^[+]{0,1}(\d+)$/
          if (!reg.test(newVal)&&newVal!='') {
            this.ruleForm.sort = oldVal
          } else {
            this.ruleForm.sort = newVal
          }
      },
      deep:true
    }
  }
};
</script>

<style lang="less" scoped>
#businessList {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.red {
  color: #f56c6c;
}
.el-table /deep/ th{
  overflow: unset;
}
</style>